/** Validadores reutilizáveis para os formulários. */
import { soDigitos, soAlfanumerico } from "./mascaras";

/** '0'-'9' -> 0-9, 'A'-'Z' -> 17-42 (código ASCII - 48), conforme o algoritmo oficial do CNPJ alfanumérico. */
function valorCaractereCnpj(char: string): number {
  return char.charCodeAt(0) - 48;
}

export function validarCpf(v: string): boolean {
  const c = soDigitos(v);
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
  let soma = 0;
  for (let i = 0; i < 9; i++) soma += Number(c[i]) * (10 - i);
  let d1 = 11 - (soma % 11);
  if (d1 >= 10) d1 = 0;
  if (d1 !== Number(c[9])) return false;
  soma = 0;
  for (let i = 0; i < 10; i++) soma += Number(c[i]) * (11 - i);
  let d2 = 11 - (soma % 11);
  if (d2 >= 10) d2 = 0;
  return d2 === Number(c[10]);
}

/** Aceita o CNPJ numérico tradicional e o novo formato alfanumérico (raiz/ordem podem ter letras). */
export function validarCnpj(v: string): boolean {
  const c = soAlfanumerico(v);
  if (c.length !== 14 || /^(.)\1{13}$/.test(c)) return false;
  if (!/^[0-9]{2}$/.test(c.slice(12))) return false;
  const digito = (base: string, pesos: number[]): number => {
    let soma = 0;
    for (let i = 0; i < pesos.length; i++) soma += valorCaractereCnpj(base[i]) * pesos[i];
    const r = soma % 11;
    return r < 2 ? 0 : 11 - r;
  };
  const p1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const p2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  if (digito(c, p1) !== Number(c[12])) return false;
  return digito(c, p2) === Number(c[13]);
}

/** Valida CPF (11, só dígitos) ou CNPJ (14, alfanumérico) pelo tamanho. */
export function validarCpfCnpj(v: string): boolean {
  const alfanum = soAlfanumerico(v);
  if (alfanum.length === 11) return validarCpf(alfanum);
  if (alfanum.length === 14) return validarCnpj(alfanum);
  return false;
}

export function validarEmail(v: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
}

export function validarTelefone(v: string): boolean {
  const d = soDigitos(v);
  return d.length === 10 || d.length === 11;
}

export function validarTelefoneFixo(v: string): boolean {
  return soDigitos(v).length === 10;
}

export function validarCelular(v: string): boolean {
  const length = soDigitos(v).length;
  return length === 10 || length === 11;
}

export function vazio(v: unknown): boolean {
  return v === null || v === undefined || String(v).trim() === "";
}
